export const addArtist = {
  namespaced: true,
  state: {
    currentStep: 1,
    artists: [],
    coupon: null,
    selected_plan: null,
    yearly_plan: null,
    billing_total: null,
    plans: [
      {
        id: "lite_monthly",
        billingDayOfMonth: null,
        billingFrequency: 1,
        currencyIsoCode: "USD",
        name: "Lite (monthly)",
        numberOfBillingCycles: null,
        price: "6.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
      {
        id: "lite_yearly",
        billingDayOfMonth: null,
        billingFrequency: 12,
        currencyIsoCode: "USD",
        name: "Lite (yearly)",
        numberOfBillingCycles: null,
        price: "60.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
      {
        id: "pro_monthly",
        billingDayOfMonth: null,
        billingFrequency: 1,
        currencyIsoCode: "USD",
        name: "Pro (monthly)",
        numberOfBillingCycles: null,
        price: "19.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
      {
        id: "pro_yearly",
        billingDayOfMonth: null,
        billingFrequency: 12,
        currencyIsoCode: "USD",
        name: "Pro (yearly)",
        numberOfBillingCycles: null,
        price: "190.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
      {
        id: "max_monthly",
        billingDayOfMonth: null,
        billingFrequency: 1,
        currencyIsoCode: "USD",
        name: "Max (monthly)",
        numberOfBillingCycles: null,
        price: "29.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
      {
        id: "max_yearly",
        billingDayOfMonth: null,
        billingFrequency: 12,
        currencyIsoCode: "USD",
        name: "Max (yearly)",
        numberOfBillingCycles: null,
        price: "290.00",
        trialDuration: 1,
        trialDurationUnit: "month",
        trialPeriod: true,
      },
    ],
  },

  mutations: {
    setData(state, data) {
      state = {
        ...state,
        ...data,
      };
    },
    setStep(state, step) {
      state.currentStep = step;
    },
    nextStep(state) {
      state.currentStep++;
    },
    previousStep(state) {
      state.currentStep--;
    },
    resetArtists(state) {
      state.artists = [];
    },
    addArtist(state, data) {
      state.artists.push(data);
    },
    setArtists(state, data) {
      state.artists = data;
    },
    removeArtist(state, spotify_id) {
      state.artists = state.artists.filter((x) => x.spotify_id !== spotify_id);
    },
    setCoupon(state, data) {
      state.coupon = data;
    },
    setSelectedPlan(state, data) {
      state.selected_plan = data;
    },
    setIsYearlyPlan(state, data) {
      state.yearly_plan = data;
    },
    setBillingTotal(state, data) {
      state.billing_total = data;
    },
    reset(state) {
      state.currentStep = 1;
      state.coupon = null;
      state.selected_plan = null;
      state.yearly_plan = null;
      state.billing_total = null;
      state.artists = [];
    },
  },
};
